// extracted by mini-css-extract-plugin
export default {"footer":"IssueFieldPicker-module__footer__yTK0h8z"};